// Copyright 2025. WebPros International GmbH. All rights reserved.

export const SET_RESPONSE_ERROR = 'response-error/SET_RESPONSE_ERROR';
export const CLEAR_RESPONSE_ERROR = 'response-error/CLEAR_RESPONSE_ERROR';
